var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineupIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.0026 14.175C8.41709 14.175 9.77365 13.6131 10.7738 12.613C11.774 11.6128 12.3359 10.2562 12.3359 8.84171C12.3359 7.42723 11.774 6.07067 10.7738 5.07048C9.77365 4.07029 8.41709 3.50838 7.0026 3.50838C5.58812 3.50838 4.23156 4.07029 3.23137 5.07048C2.23117 6.07067 1.66927 7.42723 1.66927 8.84171C1.66927 10.2562 2.23117 11.6128 3.23137 12.613C4.23156 13.6131 5.58812 14.175 7.0026 14.175ZM7.0026 2.17505C7.87808 2.17505 8.74499 2.34749 9.55383 2.68252C10.3627 3.01755 11.0976 3.50861 11.7166 4.12767C12.3357 4.74673 12.8268 5.48165 13.1618 6.29049C13.4968 7.09933 13.6693 7.96624 13.6693 8.84171C13.6693 10.6098 12.9669 12.3055 11.7166 13.5558C10.4664 14.806 8.77071 15.5084 7.0026 15.5084C3.31594 15.5084 0.335938 12.5084 0.335938 8.84171C0.335938 7.07361 1.03832 5.37791 2.28856 4.12767C3.5388 2.87743 5.23449 2.17505 7.0026 2.17505ZM7.33594 5.50838V9.00838L10.3359 10.7884L9.83594 11.6084L6.33594 9.50838V5.50838H7.33594Z",
    fill: "#9BA4AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineupIcon);
export default __webpack_public_path__ + "static/media/lineup-icon.8c68730330b1e8d1285c7eb0a11a848e.svg";
export { ForwardRef as ReactComponent };